import React from "react";
import Banner from "../../sections/Banner.js";
import General from "../../sections/General.js";
import AboutUs from "../../sections/AboutUs.js";
import Platfrom from "../../sections/Platform.js";
import Registration from "../../sections/Registration.js";
import Education from "../../sections/Education.js";
import Theme from "../../sections/Theme.js";
import SEO from "../../sections/SEO.js";
import SocialMedia from "../../sections/SocialMedia.js";
import PaymentMethod from "../../sections/PaymentMethod.js";
import ContactUs from "../../sections/ContactUs.js";
import QuickLink from "../../sections/QuickLink.js";
import Footer from "../../sections/Footer.js";
import Languages from "../../sections/Languages.js";
import Menu from "../../sections/Menu.js";
import AccountTypes from "../../sections/AccountTypes.js";
import HelpCenter from "../../sections/HelpCenter.js";
import Terms from "../../sections/Terms.js";
import Analysis from "../../sections/Analysis.js";
import Instructor from "../../sections/Instructor.js";
import MyAccount from "../../sections/MyAccount.js";
import ServicesCards from "../../sections/ServicesCards.js";
import PLC from "../../sections/PLC.js";
import MC from "../../sections/MC.js";
import SC from "../../sections/SC.js";
import Videos from "../../sections/Videos.js";
import Categories from "../../sections/Categories.js";
import Blog from "../../sections/Blog.js";
import AccountTypesPage from "../../sections/AccountTypesPage.js";
import DandW from "../../sections/DandW.js";
import DandWBody from "../../sections/DandWBody.js";
import AboutSection from "../../sections/AboutSection.js";
import Instruments from "../../sections/Instruments.js";
import Admin from "../../sections/Admin.js";
import Sitemap from "../../sections/Sitemap.js";
import Redirects from "../../sections/Redirects.js";
import Promotions from "../../sections/Promotions.js";
import Promos from "../../sections/Promos.js";
import PartnershipFAQ from "../../sections/PartnershipFAQ.js";
import Newsletter from "../../sections/Newsletter.js";
import IB from "../../sections/IB.js";
import Partnership from "../../sections/Partnership.js";
import HistorySlider from "../../sections/HistorySlider.js";
import Employment from "../../sections/Employment.jsx";
import AnnouncementMessage from "../../sections/AnnouncementMessage.jsx";
import Appointment from "../../sections/Appointment.jsx";
import ContestMarketing from "../../sections/ContestMarketing.jsx";

function Content({ content, user }) {

  return (
    <div>
      {content == "Languages" && <Languages user={user} />}
      {content == "General" && <General user={user} />}
      {content == "SEO" && <SEO user={user} />}
      {content == "Menu" && <Menu user={user} />}
      {content == "Social Media" && <SocialMedia user={user} />}
      {content == "Theme" && <Theme user={user} />}
      {content == "Banner" && <Banner user={user} />}
      {content == "About Section" && <AboutSection user={user} />}
      {content == "About Us" && <AboutUs user={user} />}
      {content == "Platfroms" && <Platfrom user={user} />}
      {content == "Registration" && <Registration user={user} />}
      {content == "Articles" && <Education user={user} />}
      {content == "Payment Methods" && <PaymentMethod user={user} />}
      {content == "Contact Us & FAQ" && <ContactUs user={user} />}
      {content == "Newsletter" && <Newsletter user={user} />}
      {content == "Quick Access Links" && <QuickLink user={user} />}
      {content == "Footer" && <Footer user={user} />}
      {content == "Account Types" && <AccountTypes user={user} />}
      {content == "Help Center" && <HelpCenter user={user} />}
      {content == "Policies" && <Terms user={user} />}
      {content == "Market Analysis" && <Analysis user={user} />}
      {content == "Instructor" && <Instructor user={user} />}
      {content == "Account" && <MyAccount user={user} />}
      {content == "Service Cards" && <ServicesCards user={user} />}
      {content == "Profit & Loss" && <PLC user={user} />}
      {content == "Margin" && <MC user={user} />}
      {content == "Spread" && <SC user={user} />}
      {content == "Videos" && <Videos user={user} />}
      {content == "Categories" && <Categories user={user} />}
      {content == "Blog" && <Blog user={user} />}
      {content == "Account Types Full" && <AccountTypesPage user={user} />}
      {content == "D&W Table" && <DandW user={user} />}
      {content == "D&W Body" && <DandWBody user={user} />}
      {content == "Instruments" && <Instruments user={user} />}
      {content == "Admin" && <Admin user={user} />}
      {content == "Sitemap" && <Sitemap user={user} />}
      {content == "Redirects" && <Redirects user={user} />}
      {content == "Promotions" && <Promotions user={user} />}
      {content == "Promos" && <Promos user={user} />}
      {content == "IB" && <IB user={user} />}
      {content == "IB Box / FAQ / Calc" && <PartnershipFAQ user={user} />}
      {content == "Partnership" && <Partnership user={user} />}
      {content == "History Slider" && <HistorySlider user={user} />}
      {content == "Employment" && <Employment user={user} />}
      {content == "Announcement Messages" && <AnnouncementMessage user={user} />}
      {content == "Appointment" && <Appointment user={user} />}
      {content == "Contest" && <ContestMarketing user={user} />}
    </div>
  );
}

export default Content;
